import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { cookies, validate } from 'src/utils';
import { fetchJson } from 'src/utils/fetch';
import { FamilyDoctorActionTypes } from './type';
// import { cookies } from 'src/utils';
// import { CDN_PREFIX } from 'src/utils/staticData';
// import storage from 'src/utils/storage';

function* fetch_family_doctor_banner() {
  while (true) {
    const action = yield take(FamilyDoctorActionTypes.FETCH_FAMILY_DOCTOR_BANNER);
    try {
      const { onSuccess } = action;
      const adTypeList = [1, 2];
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/ad/list/rightGlobalPopup', type: 'POST', data: {
          adPositionList: ['health_manage_banner'],
          channelResourceCode: cookies.get('channelResourceCode') || '',
          option: { needAdPicture: true, needFilterExcludeResource: true },
          adTypeList: validate.isFromMiniApplet() ? [...adTypeList, 3] : adTypeList,
        },
        isloading: true,
        action,
      });
      if (res && res.code === '0') {
        const banners = (res.result || []).filter((item: any) => !(item.alipayShow === 'N' && validate.isAlipayApplet()));
        const bannerList = banners.map((banner) => ({
          url: banner.attachmentDomain.attachmentDownloadUrl,
          type: banner.adType,
          link: banner.adRequestUrl,
          appId: banner.targetAppId,
          extraData: banner.extraData,
          adName: banner.adName || '',
        }));
        yield put({
          type: FamilyDoctorActionTypes.UPDATE_FAMILY_DOCTOR_INFO, data: {
            bannerList,
          },
        });
        typeof onSuccess === 'function' && onSuccess(res);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_doctor_evaluate--------' , error);
    }
  }
}

function* fetch_family_doctor_service() {
  while (true) {
    const action = yield take(FamilyDoctorActionTypes.FETCH_FAMILY_DOCTOR_SERVICE);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/user/servpack/listIndex', type: 'POST', data: {
          servpackBizTypeList: [2, 3], // "服务包业务类型,1-普通 2-家医体验版 3-家医正式版
        },
        isloading: false,
        action,
      });
      if (res && res.code === '0') {
        const { userServpackDomain = {}, favourCountdownTime = '' } = res.result || {};
        yield put({
          type: FamilyDoctorActionTypes.UPDATE_FAMILY_DOCTOR_INFO, data: {
            favourCountdownTime,
            tryOutOrContinuedFeePoup: !!favourCountdownTime,
            userServpackDomain,
            isBuyedServpack: Object.keys(userServpackDomain).length ? 'Y' : 'N',
          },
        });
        typeof onSuccess === 'function' && onSuccess(res);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_doctor_evaluate--------' , error);
    }
  }
}

// 查询绑定医生
function* fetch_family_doctor_signed() {
  while (true) {
    const action = yield take(FamilyDoctorActionTypes.FETCH_FAMILY_DOCTOR_SIGNED);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/medical/doctor/butler/getButlerDoctorByUser', type: 'POST',
        isloading: false,
        action,
      });
      if (res && res.code === '0') {
        const { medicalStaffView = {},isDoctorNormalService = '' , bindTime = '', ...other } = res.result || {};
        // let tryOutOrContinuedFeePoup= true; //是否展示 老用户试用 or 续费弹窗
        // const isFirstDrawTrialServpack = storage.get('isFirstDrawTrialServpack') || 'N';
        // if(isFirstDrawTrialServpack == 'N'){
        //   tryOutOrContinuedFeePoup = false;
        // }

        const { attachmentList = [] } = medicalStaffView;
        const info: any = {};
        attachmentList.map(({ attachmentType, attachmentDownloadUrl }) => {
          info[attachmentType] = attachmentDownloadUrl;
        });
        yield put({
          type: FamilyDoctorActionTypes.UPDATE_FAMILY_DOCTOR_INFO, data: {
            isBindDoctor: isDoctorNormalService === 'Y',
            isDoctorNormalService,
            bindDoctorInfo: {
              ...medicalStaffView,
              bindTime: Math.floor((Date.now() - new Date(bindTime.replace(/-/g, '/')).getTime()) / (1000 * 60 * 60 * 24)) + 1,
              ...other,
              ...info,
            },
          },
        });
        typeof onSuccess === 'function' && onSuccess(res);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_doctor_evaluate--------' + error.message);
    }
  }
}

// 查询医生列表
function* fetch_family_doctor_list() {
  while (true) {
    const action = yield take(FamilyDoctorActionTypes.FETCH_FAMILY_DOCTOR_LIST);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/doctor/getSignDoctorList', type: 'POST',
        data: {
          option: {
            isQueryHeadPortrait: true,
          },
        },
        isloading: true,
        action,
      });
      if (res && res.code === '0') {
        yield put({
          type: FamilyDoctorActionTypes.UPDATE_FAMILY_DOCTOR_INFO, data: {
            doctorList: res.result,
          },
        });
        typeof onSuccess === 'function' && onSuccess(res);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_doctor_evaluate--------' + error.message);
    }
  }
}

// 绑定医生
function* fetch_family_doctor_signDoctor() {
  while (true) {
    const action = yield take(FamilyDoctorActionTypes.FETCH_FAMILY_DOCTOR_SIGNDOCTOR);
    try {
      const { data, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/medical/doctor/butler/bindDoctor', type: 'POST',
        data,
        isloading: true,
        action,
      });
      if (res && res.code === '0') {
        yield put({
          type: FamilyDoctorActionTypes.UPDATE_FAMILY_DOCTOR_INFO, data: {
            isBindDoctor: true,
            bindDoctorInfo: res.result.medicalStaffView,
          },
        });
        typeof onSuccess === 'function' && onSuccess(res);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_doctor_evaluate--------' + error.message);
    }
  }
}

// 查询权益
function* fetch_family_doctor_rights() {
  while (true) {
    const action = yield take(FamilyDoctorActionTypes.FETCH_FAMILY_DOCTOR_RIGHTS);
    try {
      const { onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/user/servpack/user/detail', type: 'POST',
        data: {
          servpackBizTypeList: [2, 3],
        },
        needLoading: true,
        action,
      });
      if (res && res.code === '0') {
        yield put({
          type: FamilyDoctorActionTypes.UPDATE_FAMILY_DOCTOR_INFO, data: {
            rights: res.result,
          },
        });
        typeof onSuccess === 'function' && onSuccess(res);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_doctor_evaluate--------' + error.message);
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_family_doctor_banner),
    fork(fetch_family_doctor_service),
    fork(fetch_family_doctor_signed),
    fork(fetch_family_doctor_list),
    fork(fetch_family_doctor_signDoctor),
    fork(fetch_family_doctor_rights),
  ]);
}
